import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styles from './AuthButton.module.scss';
const AuthButton = ({ text, onClick, type = 'submit', disabled }) => {
    return (_jsx("button", Object.assign({ disabled: disabled, className: styles.auth__button, onClick: onClick, type: type, "data-testid": "auth-button" }, { children: text })));
};
export default AuthButton;
